import { createContext, useContext } from 'react';
import { translate } from '../i18n/catalog';

const defaultContext = { language: 'en', direction: 'ltr', t: (key, fallback, params) => translate('en', key, fallback, params),
  languages: [], loading: false, saving: false, error: '', canSelect: false, setLanguage: () => false, retry: () => {} };
export const LanguageContext = createContext(defaultContext);
export const useLanguage = () => useContext(LanguageContext);
export const languageStorageKey = tenantId => `panel-language:v1:${tenantId}`;

